import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Cadastro } from 'app/shared/interfaces/cadastro';
import { CadastroAnaliseCredito } from 'app/shared/interfaces/cadastro-analise-credito';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { CadastroService } from 'app/shared/services/cadastro.service';

@Component({
  selector: 'app-cadastro-anacred-popup',
  templateUrl: './cadastro-anacred-popup.component.html',
  styleUrls: ['./cadastro-anacred-popup.component.scss']
})
export class CadastroAnacredPopupComponent implements OnInit {

  layoutConf: any;
  cadastro: Cadastro;
  analiseCredito: CadastroAnaliseCredito;
  anacredForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CadastroAnacredPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private loader: AppLoaderService,
    private cadastroService: CadastroService,
  ) { }

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.cadastro = this.data.payload;
    this.anacredForm = this.fb.group({
      chkAnaliseCredito: [this.cadastro?.chkAnaliseCredito ?? true],
      limiteCredito: [this.cadastro?.limiteCredito ?? 0],
    });
    this.loader.open();
    this.cadastroService.getAnaliseCreditoDetails(this.cadastro?.id?.toString()).subscribe({
      next: analise => {
        this.analiseCredito = analise;
        this.loader.close();
      },
      error: err => {
        this.loader.close();
        this.confirmService.confirm({
          message: `ERRO AO CARREGAR ANÁLISE DE CRÉDITO: ${err}`,
          error: true
        });
      }
    });
  }

  save() {
    const payload: Cadastro = {
      ...this.cadastro,
      ...this.anacredForm.getRawValue(),
    };

    this.loader.open();
    this.cadastroService.saveOrUpdate(payload).subscribe({
      next: val => {
        this.cadastro = val;
        this.anacredForm.patchValue({
          chkAnaliseCredito: val?.chkAnaliseCredito ?? true,
          limiteCredito: val?.limiteCredito ?? 0,
        });
        this.loader.close();
        this.confirmService.confirm({
          title: 'Sucesso',
          message: 'Análise de crédito atualizada com sucesso.',
          error: false,
        });
      },
      error: err => {
        this.loader.close();
        this.confirmService.confirm({
          message: `ERRO AO SALVAR ANÁLISE DE CRÉDITO: ${err}`,
          error: true,
        });
      }
    });
  }

  close() {
    this.dialogRef.close(this.cadastro);
  }

}
